import $ from 'jquery';
window.jQuery = $;
require('./plugins/off-menu');